import { create } from 'zustand'
import { useSpring } from '@react-spring/web'

interface ScrollStore {
  scrollPct: number
  scrollStagePct: number
  scrollStage: number
}

// TODO: Créer un spring

const useScrollStore = create<ScrollStore>(() => ({
  scrollPct: 0,
  scrollStagePct: 0,
  scrollStage: 0,
}))

export default useScrollStore
